import * as React from 'react';
import { StyleSheet } from 'react-native';

import { LoadingSkeleton } from '@/components/SkeletonLoader';
import { Box } from '@/components/lib/components/Box';
import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

import { FIRST_TOP10_CARD_SIZE, PopularPlayerNumberIcon, TOP10_CARD_SIZE } from '../PopularPlayersList';

export const PlayerSmallCardSkeleton = ({
    isFirstItem,
    hasTwoDigits,
    position,
    isLastItem,
    showNumber,
}: {
    isFirstItem: boolean;
    isLastItem: boolean;
} & (
    | {
          showNumber: true;
          hasTwoDigits: boolean;
          position: number;
      }
    | {
          showNumber: false;
          hasTwoDigits?: boolean;
          position?: number;
      }
)) => {
    return (
        <Box marginLeft={isFirstItem ? 's16' : 's0'} marginRight={isLastItem ? 's16' : 's0'}>
            <Box
                style={
                    showNumber
                        ? { ...styles.cardContainer, width: isFirstItem ? FIRST_TOP10_CARD_SIZE : TOP10_CARD_SIZE }
                        : undefined
                }
            >
                <Box backgroundColor={ds.colorToken.background.neutral.subtler} borderRadius={'r16'}>
                    <LoadingSkeleton
                        skeletonColor={designSystem.colors.neutral300}
                        width={72}
                        height={102.75}
                        borderRadius="r16"
                    />
                </Box>
                <LoadingSkeleton
                    skeletonColor={designSystem.colors.neutral300}
                    width={72}
                    height={20}
                    borderRadius="r4"
                    marginTop="s10"
                />
            </Box>
            {showNumber ? (
                <PopularPlayerNumberIcon position={position} isFirstItem={isFirstItem} hasTwoDigits={hasTwoDigits} />
            ) : null}
        </Box>
    );
};

const styles = StyleSheet.create({
    cardContainer: {
        alignItems: 'flex-end',
    },
});
